import React from 'react';
import '../../css/pages.css';
//import PropTypes from 'prop-types'; // ES6
let gk = require('../../data/ent1.json');

let shuffle1 = require('shuffle-array'), q1 = 
               [ gk.results[0].incorrect_answers[0],  gk.results[0].incorrect_answers[1], gk.results[0].incorrect_answers[2], gk.results[0].correct_answer ];

let question1 = shuffle1(q1);

let shuffle2 = require('shuffle-array'), q2 = 
               [ gk.results[1].incorrect_answers[0],  gk.results[1].incorrect_answers[1], gk.results[1].incorrect_answers[2], gk.results[1].correct_answer ];

let question2 = shuffle2(q2);

let shuffled = require('shuffle-array'), q3 = 
               [ gk.results[2].incorrect_answers[0],  gk.results[2].incorrect_answers[1], gk.results[2].incorrect_answers[2], gk.results[2].correct_answer ];

let question3 = shuffled(q3);

let shuffle4 = require('shuffle-array'), q4 = 
               [ gk.results[3].incorrect_answers[0],  gk.results[3].incorrect_answers[1], gk.results[3].incorrect_answers[2], gk.results[3].correct_answer ];

let question4 = shuffle4(q4);

let shuffle5 = require('shuffle-array'), q5 = 
               [ gk.results[4].incorrect_answers[0],  gk.results[4].incorrect_answers[1], gk.results[4].incorrect_answers[2], gk.results[4].correct_answer ];

let question5 = shuffle5(q5);

let shuffle6 = require('shuffle-array'), q6 = 
               [ gk.results[5].incorrect_answers[0],  gk.results[5].incorrect_answers[1], gk.results[5].incorrect_answers[2], gk.results[5].correct_answer ];

let question6 = shuffle6(q6);

let shuffle7 = require('shuffle-array'), q7 = 
               [ gk.results[6].incorrect_answers[0],  gk.results[6].incorrect_answers[1], gk.results[6].incorrect_answers[2], gk.results[6].correct_answer ];

let question7 = shuffle7(q7);

let shuffle8 = require('shuffle-array'), q8 = 
               [ gk.results[7].incorrect_answers[0],  gk.results[7].incorrect_answers[1], gk.results[7].incorrect_answers[2], gk.results[7].correct_answer ];

let question8 = shuffle8(q8);

let shuffle9 = require('shuffle-array'), q9 = 
               [ gk.results[8].incorrect_answers[0],  gk.results[8].incorrect_answers[1], gk.results[8].incorrect_answers[2], gk.results[8].correct_answer ];

let question9 = shuffle9(q9);

let shuffle10 = require('shuffle-array'), q10 = 
               [ gk.results[9].incorrect_answers[0],  gk.results[9].incorrect_answers[1], gk.results[9].incorrect_answers[2], gk.results[9].correct_answer ];

let question10 = shuffle10(q10);

class Ent1 extends React.Component {

  handleSubmit = (e) => {
    e.preventDefault();

    let score = 0;
    let analysis = "";
    //  extract the node list from the form
    //  it looks like an array, but lacks array methods
    const { q1 } = this.form;
    const { q2 } = this.form;
    const { q3 } = this.form;
    const { q4 } = this.form;
    const { q5 } = this.form;
    const { q6 } = this.form;
    const { q7 } = this.form;
    const { q8 } = this.form;
    const { q9 } = this.form;
    const { q10 } = this.form;

    // a set of radios only has one value

    console.log(q1.value);
    if( q1.value === gk.results[0].correct_answer) {
    console.log("Question 1 correct");
    score++;
    analysis = "Question 1 correct\n";
    console.log(score);
    } else {
    console.log("Question 1 wrong");
    analysis = "Question 1 wrong\n";
    }

    console.log(q2.value);
    if( q2.value === gk.results[1].correct_answer) {
    console.log("Question 2 correct");
    score++;
    analysis += "Question 2 correct\n";
    console.log(score);
    } else {
    console.log("Question 2 wrong");
    analysis += "Question 2 wrong\n";
    }

    console.log(q3.value);
    if( q3.value === gk.results[2].correct_answer) {
    console.log("Question 3 correct");
    analysis += "Question 3 correct\n";
    score++;
    console.log(score);
    } else {
    console.log("Question 3 wrong");
    analysis += "Question 3 wrong\n";
    }

    console.log(q4.value);
    if( q4.value === gk.results[3].correct_answer) {
    console.log("Question 4 correct");
    analysis += "Question 4 correct\n";
    score++;
    console.log(score);
    } else {
    console.log("Question 4 wrong");
    analysis += "Question 4 wrong\n";
    }

    console.log(q5.value);
    if( q5.value === gk.results[4].correct_answer) {
    console.log("Question 5 correct");
    analysis += "Question 5 correct\n";
    score++;
    console.log(score);
    } else {
    console.log("Question 5 wrong");
    analysis += "Question 5 wrong\n";
    }

    console.log(q6.value);
    if( q6.value === gk.results[5].correct_answer) {
    console.log("Question 6 correct");
    analysis += "Question 6 correct\n";
    score++;
    console.log(score);
    } else {
    console.log("Question 6 wrong");
    analysis += "Question 6 wrong\n";
    }

    console.log(q7.value);
    if( q7.value === gk.results[6].correct_answer) {
    console.log("Question 7 correct");
    analysis += "Question 7 correct\n";
    score++;
    console.log(score);
    } else {
    console.log("Question 7 wrong");
    analysis += "Question 7 wrong\n";
    }

    console.log(q8.value);
    if( q8.value === gk.results[7].correct_answer) {
    console.log("Question 8 correct ");
    analysis += "Question 8 correct\n";
    score++;
    console.log(score);
    } else {
    console.log("Question 8 wrong");
    analysis += "Question 8 wrong\n";
    }

    console.log(q9.value);
    if( q9.value === gk.results[8].correct_answer) {
    console.log("Question 9 correct");
    analysis += "Question 9 correct\n";
    score++;
    console.log(score);
    } else {
    console.log("Question 9 wrong");
    analysis += "Question 9 wrong\n";
    }

    console.log(q10.value);
    if( q10.value === gk.results[9].correct_answer) {
    console.log("Question 10 correct");
    analysis += "Question 10 correct\n";
    score++;
    console.log(score);
    } else {
    console.log("Question 10 wrong");
    analysis += "Question 10 wrong\n";
    }

    alert('Your score was: ' + score + ' out of 10!\n' + analysis);
  }
    

render() {
 //const op1 = this.props.q1;
  return (
    <div className="entBG">
      <br />
      <h1>Entertainment Quiz</h1><br />
        
      <form onSubmit={this.handleSubmit}
          ref={form => this.form = form}>  
        <div>
        { /* Question 1 */ }
        <h5>1. { gk.results[0].question } </h5>
        
            <div className="custom-control custom-radio justifyContentEnd">
              
              <input type="radio" id="1a" name="q1" value={ question1[0] } className="custom-control-input" />
            
              <label className="custom-control-label" htmlFor="1a">{ question1[0] }</label>
        </div>

        
        <div className="custom-control custom-radio justifyContentEnd">
          <input type="radio" id="1b" name="q1" className="custom-control-input" 
          value={ question1[1] }/>
        
          <label className="custom-control-label" htmlFor="1b">{ question1[1] }</label>
          
        </div>

       
        <div className="custom-control custom-radio justifyContentEnd">
          <input type="radio" id="1c" name="q1" className="custom-control-input" value={ question1[2] } />

          <label className="custom-control-label" htmlFor="1c">{ question1[2] }</label>
        
        </div>

        <div className="custom-control custom-radio justifyContentEnd">
          <input type="radio" id="1d" name="q1" className="custom-control-input" value={ question1[3] } />
          <label className="custom-control-label" htmlFor="1d">{ question1[3] }</label>
        </div><br />

        { /* Question 2 */ }
        <h5>2. { gk.results[1].question } </h5>
        
            <div className="custom-control custom-radio justifyContentEnd">
              
              <input type="radio" id="2a" name="q2" className="custom-control-input"
              value={ question2[0] } />
            
              <label className="custom-control-label" htmlFor="2a">{ question2[0] }</label>
        </div>

        
        <div className="custom-control custom-radio justifyContentEnd">
          <input type="radio" id="2b" name="q2" className="custom-control-input" value={ question2[1] }/>
        
          <label className="custom-control-label" htmlFor="2b">{ question2[1] }</label>
          
        </div>

       
        <div className="custom-control custom-radio justifyContentEnd">
          <input type="radio" id="2c" name="q2" className="custom-control-input" value={ question2[2] }/>

          <label className="custom-control-label" htmlFor="2c">{ question2[2] }</label>
        
        </div>

        <div className="custom-control custom-radio justifyContentEnd">
          <input type="radio" id="2d" name="q2" className="custom-control-input" value={ question2[3] } />
          <label className="custom-control-label" htmlFor="2d">{ question2[3] }</label>
        </div><br />


        {/* Question 3 */}
        <h5>3.{ gk.results[2].question } </h5>
        
            <div className="custom-control custom-radio justifyContentEnd">
              
              <input type="radio" id="3a" name="q3" className="custom-control-input" value={ question3[0] } />
            
              <label className="custom-control-label" htmlFor="3a">{ question3[0] }</label>
        </div>

        
        <div className="custom-control custom-radio justifyContentEnd">
          <input type="radio" id="3b" name="q3" className="custom-control-input" value={ question3[1] } />
        
          <label className="custom-control-label" htmlFor="3b">{ question3[1] }</label>
          
        </div>

       
        <div className="custom-control custom-radio justifyContentEnd">
          <input type="radio" id="3c" name="q3" className="custom-control-input" value={ question3[2] } />

          <label className="custom-control-label" htmlFor="3c">{ question3[2] }</label>
        
        </div>

        <div className="custom-control custom-radio justifyContentEnd">
          <input type="radio" id="3d" name="q3" className="custom-control-input" value={ question3[3] }/>
          <label className="custom-control-label" htmlFor="3d">{ question3[3] }</label>
        </div><br />

        { /* Question 4 */ }
        <h5>4. { gk.results[3].question } </h5>
        
            <div className="custom-control custom-radio justifyContentEnd">
              
              <input type="radio" id="4a" name="q4" className="custom-control-input" value={ question4[0] }/>
            
              <label className="custom-control-label" htmlFor="4a">{ question4[0] }</label>
        </div>

        
        <div className="custom-control custom-radio justifyContentEnd">
          <input type="radio" id="4b" name="q4" className="custom-control-input" value={ question4[1] } />
        
          <label className="custom-control-label" htmlFor="4b">{ question4[1] }</label>
          
        </div>

       
        <div className="custom-control custom-radio justifyContentEnd">
          <input type="radio" id="4c" name="q4" className="custom-control-input" value={ question4[2] }/>

          <label className="custom-control-label" htmlFor="4c">{ question4[2] }</label>
        
        </div>

        <div className="custom-control custom-radio justifyContentEnd">
          <input type="radio" id="4d" name="q4" className="custom-control-input" value={ question4[3] } />
          <label className="custom-control-label" htmlFor="4d">{ question4[3] }</label>
        </div><br />


        {/* Question 5 */}
        <h5>5.{ gk.results[4].question } </h5>
        
            <div className="custom-control custom-radio justifyContentEnd">
              
              <input type="radio" id="5a" name="q5" className="custom-control-input" value={ question5[0] } />
            
              <label className="custom-control-label" htmlFor="5a">{ question5[0] }</label>
        </div>

        
        <div className="custom-control custom-radio justifyContentEnd">
          <input type="radio" id="5b" name="q5" className="custom-control-input" value={ question5[1] }/>
        
          <label className="custom-control-label" htmlFor="5b">{ question5[1] }</label>
          
        </div>

       
        <div className="custom-control custom-radio justifyContentEnd">
          <input type="radio" id="5c" name="q5" className="custom-control-input" value={ question5[2] }/>

          <label className="custom-control-label" htmlFor="5c">{ question5[2] }</label>
        
        </div>

        <div className="custom-control custom-radio justifyContentEnd">
          <input type="radio" id="5d" name="q5" className="custom-control-input" value={ question5[3] }/>
          <label className="custom-control-label" htmlFor="5d">{ question5[3] }</label>
        </div><br />

       { /* Question 6 */ }
        <h5>6. { gk.results[5].question } </h5>
        
            <div className="custom-control custom-radio justifyContentEnd">
              
              <input type="radio" id="6a" name="q6" className="custom-control-input" value={ question6[0] }/>
            
              <label className="custom-control-label" htmlFor="6a">{ question6[0] }</label>
        </div>

        
        <div className="custom-control custom-radio justifyContentEnd">
          <input type="radio" id="6b" name="q6" className="custom-control-input" value={ question6[1] }/>
        
          <label className="custom-control-label" htmlFor="6b">{ question6[1] }</label>
          
        </div>

       
        <div className="custom-control custom-radio justifyContentEnd">
          <input type="radio" id="6c" name="q6" className="custom-control-input" value={ question6[2] }/>

          <label className="custom-control-label" htmlFor="6c">{ question6[2] }</label>
        
        </div>

        <div className="custom-control custom-radio justifyContentEnd">
          <input type="radio" id="6d" name="q6" className="custom-control-input" value={ question6[3] }/>
          <label className="custom-control-label" htmlFor="6d">{ question6[3] }</label>
        </div><br />

        { /* Question 7 */ }
        <h5>7. { gk.results[6].question } </h5>
        
            <div className="custom-control custom-radio justifyContentEnd">
              
              <input type="radio" id="7a" name="q7" className="custom-control-input" value={ question7[0] }/>
            
              <label className="custom-control-label" htmlFor="7a">{ question7[0] }</label>
        </div>

        
        <div className="custom-control custom-radio justifyContentEnd">
          <input type="radio" id="7b" name="q7" className="custom-control-input" value={ question7[1] }/>
        
          <label className="custom-control-label" htmlFor="7b">{ question7[1] }</label>
          
        </div>

       
        <div className="custom-control custom-radio justifyContentEnd">
          <input type="radio" id="7c" name="q7" className="custom-control-input" value={ question7[2] }/>

          <label className="custom-control-label" htmlFor="7c">{ question7[2] }</label>
        
        </div>

        <div className="custom-control custom-radio justifyContentEnd">
          <input type="radio" id="7d" name="q7" className="custom-control-input" value={ question7[3] }/>
          <label className="custom-control-label" htmlFor="7d">{ question7[3] }</label>
        </div><br />


        {/* Question 8 */}
        <h5>8.{ gk.results[7].question } </h5>
        
            <div className="custom-control custom-radio justifyContentEnd">
              
              <input type="radio" id="8a" name="q8" className="custom-control-input" value={ question8[0] }/>
            
              <label className="custom-control-label" htmlFor="8a">{ question8[0] }</label>
        </div>

        
        <div className="custom-control custom-radio justifyContentEnd">
          <input type="radio" id="8b" name="q8" className="custom-control-input" value={ question8[1] }/>
        
          <label className="custom-control-label" htmlFor="8b">{ question8[1] }</label>
          
        </div>

       
        <div className="custom-control custom-radio justifyContentEnd">
          <input type="radio" id="8c" name="q8" className="custom-control-input" value={ question8[2] }/>

          <label className="custom-control-label" htmlFor="8c">{ question8[2] }</label>
        
        </div>

        <div className="custom-control custom-radio justifyContentEnd">
          <input type="radio" id="8d" name="q8" className="custom-control-input" value={ question8[3] }/>
          <label className="custom-control-label" htmlFor="8d">{ question8[3] }</label>
        </div><br />

        { /* Question 9 */ }
        <h5>9. { gk.results[8].question } </h5>
        
            <div className="custom-control custom-radio justifyContentEnd">
              
              <input type="radio" id="9a" name="q9" className="custom-control-input" value={ question9[0] }/>
            
              <label className="custom-control-label" htmlFor="9a">{ question9[0] }</label>
        </div>

        
        <div className="custom-control custom-radio justifyContentEnd">
          <input type="radio" id="9b" name="q9" className="custom-control-input" value={ question9[1] }/>
        
          <label className="custom-control-label" htmlFor="9b">{ question9[1] }</label>
          
        </div>

       
        <div className="custom-control custom-radio justifyContentEnd">
          <input type="radio" id="9c" name="q9" className="custom-control-input" value={ question9[2] }/>

          <label className="custom-control-label" htmlFor="9c">{ question9[2] }</label>
        
        </div>

        <div className="custom-control custom-radio justifyContentEnd">
          <input type="radio" id="9d" name="q9" className="custom-control-input" value={ question9[3] }/>
          <label className="custom-control-label" htmlFor="9d">{ question9[3] }</label>
        </div><br />


        {/* Question 10 */}
        <h5>10.{ gk.results[9].question } </h5>
        
            <div className="custom-control custom-radio justifyContentEnd">
              
              <input type="radio" id="10a" name="q10" className="custom-control-input" value={ question10[0] }/>
            
              <label className="custom-control-label" htmlFor="10a">{ question10[0] }</label>
        </div>

        
        <div className="custom-control custom-radio justifyContentEnd">
          <input type="radio" id="10b" name="q10" className="custom-control-input" value={ question10[1] }/>
        
          <label className="custom-control-label" htmlFor="10b">{ question10[1] }</label>
          
        </div>

       
        <div className="custom-control custom-radio justifyContentEnd">
          <input type="radio" id="10c" name="q10" className="custom-control-input" value={ question10[2] }/>

          <label className="custom-control-label" htmlFor="10c">{ question10[2] }</label>
        
        </div>

        <div className="custom-control custom-radio justifyContentEnd">
          <input type="radio" id="10d" name="q10" className="custom-control-input" value={ question10[3] }/>
          <label className="custom-control-label" htmlFor="10d">{ question10[3] }</label>
        </div><br />

       </div>
       <button type="submit" className="btn btn-primary">Submit</button>
      </form>
</div>   
  );
};
};

export default Ent1;


// WEBPACK FOOTER //
// ./src/components/layout/ent1.jsx